import { Form } from 'react-bootstrap';
import { WebhookEventHelpTip } from './WebhookEventHelpTip';
import { ExcludedBucketHelpTip } from './ExcludedBucketHelpTip';
import { WEBHOOK_BUCKET_FILTER_OPTIONS } from '../lib/webhook-bucket-filters';
import {
  EXCLUDED_COVERAGE_FILTER_OPTIONS,
  isExcludedSubFilterChecked,
  isExcludedSubFilterExplicit,
  toggleExcludedSubFilter,
  toggleWebhookBucketFilter,
} from '../lib/excluded-coverage-filters';

export function ScheduleWebhookBucketFilters({
  title = 'محدودسازی وضعیت',
  filters,
  onChange,
  persianOnly = false,
}: {
  title?: string;
  filters: string[];
  onChange: (filters: string[]) => void;
  /** بدون نمایش شناسهٔ انگلیسی bucket در UI زمان‌بندی */
  persianOnly?: boolean;
}) {
  const excludedSelected = filters.includes('excluded');

  function toggleBucket(filterId: string) {
    const checked = !filters.includes(filterId);
    onChange(toggleWebhookBucketFilter(filters, filterId, checked));
  }

  function toggleSubFilter(subId: string) {
    const checked = !isExcludedSubFilterChecked(filters, subId);
    onChange(toggleExcludedSubFilter(filters, subId, checked));
  }

  return (
    <div className="mb-3">
      <Form.Label className="mb-2">
        {title}
        <WebhookEventHelpTip
          title={title}
          paragraphs={[
            'فقط برای «وضعیت فعلی هر آدرس» و «فقط وقتی وضعیت عوض شد».',
            'برای ایندکس‌نشده، پیش‌فرض همهٔ حالت‌ها فعال است؛ می‌توانید مثلاً فقط noindex را نگه دارید.',
            'اگر هیچ وضعیتی تیک نخورده باشد، هنگام ذخیره همهٔ وضعیت‌ها فعال می‌شوند.',
          ]}
        />
      </Form.Label>
      <div className="d-grid gap-2">
        {WEBHOOK_BUCKET_FILTER_OPTIONS.map((item) => (
          <div key={item.id}>
            <Form.Check
              type="checkbox"
              id={`webhook-bucket-filter-${item.id}`}
              label={
                <>
                  <span>{item.label}</span>
                  {!persianOnly && (
                    <span className="text-secondary small mono ms-2">{item.id}</span>
                  )}
                  {item.id === 'excluded' ? (
                    <ExcludedBucketHelpTip placement="top" />
                  ) : (
                    <WebhookEventHelpTip
                      title={item.label}
                      paragraphs={[item.description]}
                    />
                  )}
                </>
              }
              checked={filters.includes(item.id)}
              onChange={() => toggleBucket(item.id)}
            />

            {item.id === 'excluded' && excludedSelected && (
              <div className="ms-4 mt-2 ps-2 border-start webhook-excluded-subfilters">
                <Form.Text className="text-secondary d-block mb-2">
                  {isExcludedSubFilterExplicit(filters)
                    ? 'فقط حالت‌های تیک‌خورده ارسال می‌شوند.'
                    : 'پیش‌فرض: همهٔ حالت‌های ایندکس‌نشده. برای محدود کردن، تیک حالت‌های ناخواسته را بردارید.'}
                </Form.Text>
                <div className="d-grid gap-2">
                  {EXCLUDED_COVERAGE_FILTER_OPTIONS.map((sub) => (
                    <Form.Check
                      key={sub.id}
                      type="checkbox"
                      id={`webhook-excluded-sub-${sub.id}`}
                      label={
                        <>
                          <span>{sub.labelFa}</span>
                          <WebhookEventHelpTip
                            title={sub.labelFa}
                            paragraphs={[
                              sub.description,
                              `پیشنهاد: ${sub.recommendWhen}`,
                            ]}
                          />
                        </>
                      }
                      checked={isExcludedSubFilterChecked(filters, sub.id)}
                      onChange={() => toggleSubFilter(sub.id)}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
